import React, { useContext } from "react";
import { debug, sortObjectsByAlphabet } from "../utils";
import { connect } from "react-redux";
import * as urlService from "../view/urlService";
import { useHistory } from "react-router-dom";
import { TableContext } from "../index";
import Select from 'react-select';

function ChooseUserField({ results = [], currentUser }) {

    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);
    const isAdmin = String(currentUser?.userRole?.name || '').toLowerCase() === 'admin';

    const onChange = (selectedOption) => {
        const user = selectedOption.value;
        setConfig({ ...config, user: user });

        if (user === 'all') {
            history.push({
                pathname: history.pathname,
                search: urlService.removeFilter('usr')
            })
            return;
        }

        const result = results.find(result => result.usr === user);
        history.push({
            pathname: history.pathname,
            search: urlService.updateFilters('usr', result.usr)
        })
    }

    let resultsCopy = results.filter(
        (obj, index, self) => index === self.findIndex((o) => o.usr === obj.usr)
    );
    resultsCopy = sortObjectsByAlphabet(resultsCopy, 'usr');

    const userOptions = resultsCopy.map(result => ({ value: result.usr, label: result.usr }));
    const options = isAdmin
        ? [{ value: 'all', label: 'All Users' }, ...userOptions]
        : [{ value: currentUser?.username || userOptions[0]?.value || 'all', label: currentUser?.username || userOptions[0]?.label || 'All Users' }];

    return (
        <Select
            className="oct_selectsearch-v2"
            classNamePrefix="oct-selectsearchsub-v2"
            value={options.find(opt => opt.value === (config.user || 'all')) || options[0]}
            onChange={onChange}
            options={options}
            isSearchable={true}
            placeholder="All Users"
        />
    );
}


function mapStateToProps(state) {
    debug("DetectionResults mapStateToProps", state);
    const mlDetectionPage = state.mlDetectionPage;
    return {
        results: mlDetectionPage.allResults,
        currentUser: state.auth
    };
}

export default connect(mapStateToProps)(ChooseUserField);
